import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from '../../core/store/definitions/definitions.resolve';
import { RefreshRelocationsFilterGuard } from '../../core/store/relocations/relocations-refresh.resolve';
import { AuthorizationGuard } from 'app/core/store/session/authorization/authorization.resolve';
import { RelocationPageContainer } from './relocation-page-container/relocation-page.container';

const routes: Routes = [
  {
    path: 'relocations',
    component: RelocationPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [AuthorizationGuard, GetDefinitionsGuard],
      authorization: 'canRelocate',
    },
  },
  {
    path: 'relocations/refresh',
    component: RelocationPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [RefreshRelocationsFilterGuard],
    },
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RelocationsRoutingModule {}
